import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class RemoveorganisationService {

  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL;
  scrollHeight: string = '22em';
  constructor(private httpClient: HttpClient, private route: Router) {

  }

  getCSRFtoken(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/removeorganisation/getcsrf`);
  }

  getorganisations(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/removeorganisation/getorganisations`);
  }

  getorgattachmentnumbers(orgid: string): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/removeorganisation/getorgattachmentnumbers/${orgid}`);
  }

  getlistoftables(orgid: string): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/removeorganisation/getlistoftables/${orgid}`);
  }

  removeOrganisation(payload): Observable<any> {
    return this.httpClient.post<any>(`${this.baseURL}/common/removeorganisation/removeorganisation`, payload);
  }


}
